import { Theme } from "@mui/material/styles";
import { CSSObject } from "tss-react/types";

export const ColorClasses = (theme: Theme): Record<MprcColorsExtended, CSSObject> => ({
    info: {
        color: theme.palette.info.main,
    },
    success: {
        color: theme.palette.success.main,
    },
    warning: {
        color: theme.palette.warning.main,
    },
    notice: {
        color: theme.palette.notice.main,
    },
    chip: {
        color: theme.palette.chip.main,
    },
    error: {
        color: theme.palette.error.main,
    },
    primary: {
        color: theme.palette.primary.main,
    },
    secondary: {
        color: theme.palette.secondary.main,
    },
    muted: {
        color: theme.palette.muted.main,
    },
    cancel: {
        color: theme.palette.cancel.main,
    },
    paper: {
        color: theme.palette.paper.main,
    },
    white: {
        color: theme.palette.common.white,
    },
    black: {
        color: theme.palette.common.black,
    },
    highlight: {
        color: theme.palette.highlight.main
    },
    inherit: {
        color: "inherit"
    },
    transparent: {
        color: "transparent"
    }
});

export const ReverseColorClasses = (theme: Theme): Record<MprcColorsExtended, CSSObject> => ({
    info: {
        backgroundColor: theme.palette.info.dark,
        color: theme.palette.info.contrastText,
    },
    success: {
        backgroundColor: theme.palette.success.dark,
        color: theme.palette.success.contrastText,
    },
    warning: {
        backgroundColor: theme.palette.warning.dark,
        color: theme.palette.warning.contrastText,
    },
    notice: {
        backgroundColor: theme.palette.notice.dark,
        color: theme.palette.notice.contrastText,
    },
    chip: {
        backgroundColor: theme.palette.chip.dark,
        color: theme.palette.chip.contrastText,
    },
    error: {
        backgroundColor: theme.palette.error.dark,
        color: theme.palette.error.contrastText,
    },
    primary: {
        backgroundColor: theme.palette.primary.dark,
        color: theme.palette.primary.contrastText,
    },
    secondary: {
        backgroundColor: theme.palette.secondary.dark,
        color: theme.palette.secondary.contrastText,
    },
    muted: {
        backgroundColor: theme.palette.muted.main,
        color: theme.palette.muted.dark,
    },
    cancel: {
        backgroundColor: theme.palette.cancel.main,
        color: theme.palette.cancel.dark,
    },
    paper: {
        backgroundColor: theme.palette.paper.main,
        color: theme.palette.paper.dark,
    },
    white: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    black: {
        backgroundColor: theme.palette.common.white,
        color: theme.palette.common.black,
    },
    highlight: {
        backgroundColor: theme.palette.highlight.dark,
        color: theme.palette.highlight.main
    },
    inherit: {
        color: "inherit"
    },
    transparent: {
        color: "transparent"
    }

});
